import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from 'src/utils/base-query.js'

export const smtpApi = createApi({
  reducerPath: 'smtpApi',
  baseQuery,
  endpoints: (builder) => ({
    addSmtpEmail: builder.mutation({
      query: (data) => ({
        method: 'POST',
        url: '/smtp/add_smtp_detail',
        body: data
      })
    }),
    getSmtpEmail: builder.mutation({
      query: () => ({
        method: 'GET',
        url: '/smtp/smtp_detail'
      })
    })
  })
})

export const {
  useAddSmtpEmailMutation,
  useGetSmtpEmailMutation
} = smtpApi
